import React, { useState } from 'react';
import { ButtonItem } from '@atlaskit/menu';
import ChevronDownIcon from '@atlaskit/icon/glyph/chevron-down';
import ChevronUpIcon from '@atlaskit/icon/glyph/chevron-up';

export const CollapsibleNavMenuWrapper = ({ children }: { children: React.ReactNode }) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const menuIcon = isExpanded ? <ChevronDownIcon label="Collapse" /> : <ChevronUpIcon label="Expand" />;

  return (
    <>
      <ButtonItem onClick={() => setIsExpanded(!isExpanded)} iconBefore={menuIcon}>
        Subscriptions
      </ButtonItem>
      {isExpanded && <div className="collapse-nav-item-container">{children}</div>}
    </>
  );
};
